module.exports = __webpack_public_path__ + "img/damen_und_herren_duefte_kachel_STARBOX.a8541f98.png";